import React from 'react';
import { Row, Col, Card, } from 'react-bootstrap';
import { connect } from 'react-redux'
import plantilla1 from '../../../assets/img/templates/plantilla1.png'
import plantilla2 from '../../../assets/img/templates/plantilla2.jpg'
import plantilla3 from '../../../assets/img/templates/plantilla3.png'
import plantilla4 from '../../../assets/img/templates/plantilla4.jpg'

function NuevaPagina({ user, token }) {

    React.useEffect(() => {

    }, [])

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Card>
                        <Card.Header>
                            Nueva Página
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col>
                                    <h2>Seleccionar la plantilla para la creación de la nueva página</h2>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <img src={plantilla1} className="card-img-top" alt="template" />
                                            <p>Plantilla 1</p>
                                            <a className="btn btn-success stretched-link" href="/pages/nueva-pagina/template1">Crear</a>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <img src={plantilla2} className="card-img-top" alt="template" />
                                            <p>Plantilla 2</p>
                                            <a className="btn btn-success stretched-link" href="/pages/nueva-pagina/template2">Crear</a>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <img src={plantilla3} className="card-img-top" alt="template" />
                                            <p>Plantilla 3</p>
                                            <a className="btn btn-success stretched-link" href="/pages/nueva-pagina/template3">Crear</a>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <img src={plantilla4} className="card-img-top" alt="template" />
                                            <p>Plantilla 4</p>
                                            <a className="btn btn-success stretched-link" href="/pages/nueva-pagina/template4">Crear</a>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {

    return {
        user: state.user.data,
        token: state.user.token
    }
}

export default connect(mapStateToProps, null)(NuevaPagina);